import LogRocket from "logrocket";

// Imported at the very top of index.js so LogRocket initialises before any
// other app module runs and can capture early network requests and logs.
// See https://docs.logrocket.com/docs/troubleshooting-sessions
// const isProduction = window.location.hostname === "app.trilodocs.com";
// console.log("Environment:", process.env.NODE_ENV, "Production:", isProduction);
const isSandbox =
  window.location.hostname === "app.sandbox.trilodocs.com" ||
  window.location.hostname.endsWith(".app.sandbox.trilodocs.com");
console.log("Environment:", process.env.NODE_ENV, "Sandbox:", isSandbox);
// if (isProduction) {
//   LogRocket.init("sagsim/trilodocs");
// }
if (isSandbox) {
  LogRocket.init("sagsim/trilodocs");
}
